import React from "react";
import { backendUrl } from "../constants";
import { useNavigate } from "react-router";
import { RoutesPaths } from "../Router/constant";

export default function AdvisorProfile({ isAdvisorUser, campaign }) {
  const navigate = useNavigate();

  const imagePath = campaign?.company?.isDefault
    ? campaign?.creator?.profilePic?.filename
    : campaign?.company?.logo;

  const imageUrl = imagePath ? `${backendUrl}${imagePath}` : null;

  const placeholder = "/assets/img/Frame1.svg";
  return (
    <div className="caAnalyticsBar">
      <div className="caAnalyticsBarHeader">
        <h3 className="m-0">{isAdvisorUser ? "Advisor profile" : "Organizer"}</h3>
      </div>
      <div className="advisorProfileOuter">
        <div className="advisorProfileContent">
          <div className="advisorProfileImg">
            <img
              className="qpOrganizerAvatar"
              src={imageUrl || placeholder}
              alt="profile"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = placeholder;
              }}
            />
          </div>
          <div>
            <h6 className="m-0">{campaign?.company?.isAdvisor ? campaign?.creator?.first_name + " " + campaign?.creator?.last_name : campaign?.company?.companyName}</h6>
            <p className="m-0">{campaign?.company?.companyRoleUser?.join(", ") || "Promoter"}</p>
          </div>
        </div>
        <div onClick={() => navigate(RoutesPaths.SHARE_PAGE.replace(":id", campaign?.company?._id))} className="viewProfile">
          <p className="m-0">View profile</p>
        </div>
      </div>
    </div>
  );
}
